import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import numeral from "numeral";
import "numeral/locales/pt-br";
import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./context/auth";
import { MenuProvider } from "./context/menus";
import { NotificationProvider } from "./context/notifications";
import Router from "./routes";
import "./styles-components.css";
import "./styles-pages.css";

moment.locale("pt-br");
numeral.locale("pt-br");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <NotificationProvider>
        <MenuProvider>
          <Router />
        </MenuProvider>
      </NotificationProvider>
    </AuthProvider>
  </React.StrictMode>
);
